var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "18",
        height: "17",
        viewBox: "0 0 18 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0 2.89307C0 1.65205 1.00898 0.643066 2.25 0.643066H15.75C16.991 0.643066 18 1.65205 18 2.89307V14.1431C18 15.3841 16.991 16.3931 15.75 16.3931H2.25C1.00898 16.3931 0 15.3841 0 14.1431V2.89307ZM2.25 5.14307V14.1431H7.875V5.14307H2.25ZM15.75 5.14307H10.125V14.1431H15.75V5.14307Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }